import ApiResponseException, { CmsApiResponseException } from './api-response-exception';
import ValidationException from './validation-exception';

export default {
  response: ApiResponseException,
  validation: ValidationException,
  cmsResponse: CmsApiResponseException
};
